var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_624_5917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33341 7.08333V2.08333C8.33341 1.61625 7.96716 1.25 7.50008 1.25C7.033 1.25 6.66675 1.61625 6.66675 2.08333V7.08333L7.50008 7.91667L8.33341 7.08333Z",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 2.91667H8.33341",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.91666H2.08333C1.86232 7.91666 1.65036 7.82886 1.49408 7.67258C1.3378 7.5163 1.25 7.30434 1.25 7.08333C1.25 6.86231 1.3378 6.65035 1.49408 6.49407C1.65036 6.33779 1.86232 6.24999 2.08333 6.24999H3.75C3.97101 6.24999 4.18298 6.1622 4.33926 6.00592C4.49554 5.84964 4.58333 5.63768 4.58333 5.41666C4.58333 5.19565 4.49554 4.98369 4.33926 4.82741C4.18298 4.67113 3.97101 4.58333 3.75 4.58333H2.5",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_624_5917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextInput);
export default __webpack_public_path__ + "static/media/textInput.ac95a3af7049600b5aee80c030f0d574.svg";
export { ForwardRef as ReactComponent };